import React from 'react';
import {ReactElement, ReactNode} from 'react';

export function isReactElement<P = any>(
  child: ReactNode
): child is ReactElement<P> {
  return React.isValidElement<P>(child);
}
